var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 520,
    viewBox: "0 0 520 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_5191)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 520,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 520,
    rx: 4,
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.9 178.863C313.9 210.893 289.768 236.859 260 236.859C230.232 236.859 206.1 210.893 206.1 178.863C206.1 178.424 206.105 177.987 206.114 177.551C194.219 182.21 178.963 188.805 173.774 191.064C172.659 191.549 171.953 192.644 171.953 193.859V239.328C171.953 241.019 173.324 242.391 175.016 242.391H200.855C200.961 242.391 201.047 242.476 201.047 242.582V328.192C201.047 329.127 201.463 330.001 202.228 330.538C207.268 334.081 228.182 347.281 260 347.281C291.818 347.281 312.732 334.081 317.772 330.538C318.537 330.001 318.953 329.127 318.953 328.192V242.486C318.953 242.433 318.996 242.391 319.049 242.391H344.984C346.676 242.391 348.047 241.019 348.047 239.328V193.859C348.047 192.644 347.341 191.549 346.226 191.064C341.037 188.805 325.781 182.21 313.886 177.551C313.895 177.987 313.9 178.424 313.9 178.863Z",
    fill: "#94979E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.148 173.433C224.769 173.074 227.391 173.372 229 173.704C230.185 173.949 230.896 175.032 230.952 176.241C231.796 194.655 244.322 207.937 260 207.937C275.678 207.937 288.204 194.655 289.048 176.241C289.104 175.032 289.815 173.949 291 173.704C292.609 173.372 295.231 173.074 298.852 173.433C299.082 175.209 299.2 177.022 299.2 178.863C299.2 201.284 281.65 219.46 260 219.46C238.35 219.46 220.8 201.284 220.8 178.863C220.8 177.022 220.918 175.209 221.148 173.433Z",
    fill: "#94979E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.9 178.863C313.9 210.893 289.768 236.859 260 236.859C230.232 236.859 206.1 210.893 206.1 178.863C206.1 178.424 206.104 177.987 206.114 177.551C206.997 177.205 207.862 176.869 208.703 176.547C213.68 174.64 217.832 173.761 221.148 173.433C220.918 175.209 220.8 177.022 220.8 178.863C220.8 201.284 238.35 219.46 260 219.46C281.65 219.46 299.2 201.284 299.2 178.863C299.2 177.022 299.082 175.209 298.852 173.433C302.168 173.761 306.32 174.64 311.297 176.547C312.138 176.869 313.003 177.204 313.886 177.551C313.895 177.987 313.9 178.424 313.9 178.863Z",
    fill: "#868A92",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_5191",
    x: 0,
    y: 0,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.721569 0 0 0 0 0.784314 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_5191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.dc4faf02b3c4793781ced3c799fa1811.svg";
export { ForwardRef as ReactComponent };